<template>
  <path
    id="mail_FILL0_wght400_GRAD0_opsz24_1_"
    data-name="mail_FILL0_wght400_GRAD0_opsz24 (1)"
    d="M82.264-781.891a2.18,2.18,0,0,1-1.6-.665,2.18,2.18,0,0,1-.665-1.6v-13.582a2.18,2.18,0,0,1,.665-1.6,2.18,2.18,0,0,1,1.6-.665h18.109a2.18,2.18,0,0,1,1.6.665,2.18,2.18,0,0,1,.665,1.6v13.582a2.18,2.18,0,0,1-.665,1.6,2.18,2.18,0,0,1-1.6.665Zm9.054-7.922-9.054-5.659v11.318h18.109v-11.318Zm0-2.264,9.054-5.659H82.264Zm-9.054-3.4v0Z"
    transform="translate(-80 800)" />
</template>
